import React from 'react'
import { faPlus, faXmark } from '@fortawesome/free-solid-svg-icons'
import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import {
  $DCprimaryColor,
  DcBreadcrumbs,
  DcButton,
  DcDiv,
  DcFlexBox,
  DcIcon,
  DcText,
  PixelCurrency,
  PixelIcon,
  PixelModal,
  PixelPageContainer,
  PixelTable,
  PixelText,
  Section,
  SectionContent,
} from 'pixel-base'

import { getBankAccounts } from 'utils/api-routes-admin'
import {
  getGeneralCourierList,
  getReceivedPayments,
} from 'utils/api-routes.util'

import CreateReceivedPayment from './components/CreateReceivedPayment'
import PaymentInvoicesDetail from './components/PaymentInvoicesDetail'

const breadcrumbs = [
  {
    name: 'Received Payments Summary',
    active: true,
  },
]

const ReceivedPayments = () => {
  const [courierSummary, setCourierSummary] = React.useState([])
  const [tableLoading, setTableLoading] = React.useState(false)
  const [showNewModal, setShowNewModal] = React.useState(false)
  const [courierPaymentId, setCourierPaymentId] = React.useState(null)
  const [showDetailModal, setShowDetailModal] = React.useState(false)
  const [couriers, setCouriers] = React.useState([])

  const [bankAccounts, setBankAccounts] = React.useState([])

  React.useEffect(() => {
    getAllCourierSummary()
    getCouriers()
  }, [])
  const getAllCourierSummary = () => {
    setTableLoading(true)
    getReceivedPayments(null).subscribe((res: any) => {
      setCourierSummary(res.response.data)
      setTableLoading(false)
    })
  }
  const getCouriers = () => {
    getGeneralCourierList().subscribe((res: any) => {
      setCouriers(res.response.data)
    })
  }
  const tenant_info: any = JSON.parse(
    localStorage.getItem('tenant_info') || '{}',
  )

  const getAllBankAccounts = () => {
    getBankAccounts().subscribe((res) => {
      setBankAccounts(res.response.data)
    })
  }
  React.useEffect(() => {
    getAllBankAccounts()
  }, [])

  const columns = [
    {
      dataKey: 'courier_name',
      name: <PixelText>Name</PixelText>,
      sortable: true,
      selector: (row) => row.courier_name || '--',
    },
    {
      dataKey: 'bank_name',
      name: <PixelText>Bank</PixelText>,
      sortable: true,
      selector: (row) => row.bank_name || '--',
    },
    {
      dataKey: 'invoice_reference',
      name: 'Invoice Reference',
      sortable: true,
      selector: (row) => row.invoice_reference || '--',
    },
    {
      dataKey: 'date_bank_credited',
      name: <PixelText>Receiving Date</PixelText>,
      sortable: true,
      selector: (row) => row.date_bank_credited || '--',
    },
    {
      dataKey: 'amount',
      name: (
        <PixelText>Amount ({tenant_info.default_currency_symbol})</PixelText>
      ),
      sortable: true,
      selector: (row) =>
        (
          <PixelCurrency
            hideSymbol={true}
            value={row.amount}
            currency={'USD'}
          />
        ) || '--',
    },
  ]
  const onRowClicked = (row) => {
    setCourierPaymentId(row.courier_payment_id)
    setShowDetailModal(true)
  }
  // navigate(`/payments/received-payments/details/${row.courier_payment_id}`)

  return (
    <>
      <DcFlexBox
        height="60px"
        fontSize="16px"
        style={{
          fontSize: '16px',
          padding: '8px 0px',
          borderBottom: '1px solid #e5e5e5',
        }}
      >
        <DcFlexBox
          justifyContent="space-between"
          alignItems="center"
          padding=".5rem 20px"
        >
          <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />

          <ProfileSection />
        </DcFlexBox>
      </DcFlexBox>

      <PixelPageContainer padding="0 ">
        <Section style={{ padding: '0px' }}>
          <SectionContent style={{ padding: '0px', borderRadius: '0px' }}>
            <DcFlexBox
              justifyContent="flex-end"
              height="auto"
              padding=" 5px 20px"
            >
              <DcButton size="sm" onClick={() => setShowNewModal(true)}>
                <PixelIcon color="white" icon={faPlus} /> Add New
              </DcButton>
            </DcFlexBox>
          </SectionContent>
        </Section>
        <Section style={{ padding: '20px' }}>
          <SectionContent>
            <PixelTable
              columns={columns}
              data={courierSummary}
              progressPending={tableLoading}
              highlightOnHover={true}
              pointerOnHover={true}
              onRowClicked={onRowClicked}
            />
          </SectionContent>
        </Section>
      </PixelPageContainer>
      <DcFlexBox
        zIndex="100"
        width="100%"
        height="100%"
        onClick={() => setShowDetailModal(false)}
        right={showDetailModal ? '0' : '-100%'}
        backgroundColor="rgba(46, 49, 74, 0.4)"
        opacity="1"
        position="absolute"
      ></DcFlexBox>

      <DcFlexBox
        zIndex="100"
        width="70%"
        height="100%"
        right={showDetailModal ? '0' : '-100%'}
        top="0"
        border="1px solid #e8e7ec"
        backgroundColor="#fff"
        padding="10px"
        position="absolute"
        flexDirection="column"
        style={{ transition: 'right 0.5s ease-in-out' }}
      >
        <DcFlexBox
          height="30px"
          width="100%"
          backgroundColor="#fff"
          padding="0 10px 10px 10px"
          justifyContent="space-between"
        >
          <DcDiv padding="0 10px 0 0">
            <DcText style={{ fontWeight: '700' }}>Details</DcText>
          </DcDiv>
          <DcDiv
            hoverStyle={{
              color: $DCprimaryColor,
              curser: 'pointer',
            }}
            color="rgba(0, 0, 0, 0.5)"
            width="15px"
          >
            <DcIcon
              onClick={() => {
                setShowDetailModal(false)
              }}
              color="inherit"
              height="50px"
              width="40px"
              fontSize="30px"
              icon={faXmark}
            />
          </DcDiv>
        </DcFlexBox>
        <DcDiv height="calc(100vh - 30px)">
          <PaymentInvoicesDetail
            payment_id={courierPaymentId}
            setShowDetailModal={setShowDetailModal}
          />
        </DcDiv>
      </DcFlexBox>
      <PixelModal
        show={showNewModal}
        handleClose={() => {
          setShowNewModal(false)
        }}
        size={'lg'}
        title={'Add a received payment'}
      >
        <CreateReceivedPayment
          couriers={couriers}
          handleClose={(data) => {
            setCourierSummary([data, ...courierSummary])
            setShowNewModal(false)
          }}
          bankAccounts={bankAccounts}
        />
      </PixelModal>
    </>
  )
}

export default ReceivedPayments
